module.exports = __webpack_public_path__ + "static/media/ftn-alandsbanken-auth.a8841f4a.svg";